<template>
  <v-col class="pa-0">
    <v-row>
      <v-col>
        <v-text-field
          v-model="newNumber"
          type="number"
          label="Spending"
          outlined />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="8"
        sm="12">
        <v-card-text class="pa-0">
          <v-container
            grid-list-xs
            pa-1>
            <v-layout
              row
              wrap
              pa0>
              <v-flex
                v-for="button in buttons"
                :key="button.key"
                xs4>
                <v-btn
                  :class="['ma-0', 'pa-10', 'calcbutton', button.class]"
                  :color="button.color"
                  block
                  depressed
                  large
                  @click="InputKey(button.key)"
                >
                  <v-icon
                    v-if="button.icon"
                    dark>
                    {{ button.icon }}
                  </v-icon>
                  <template v-else>
                    {{ button.label }}
                  </template>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          v-if="isNewMember"
          outlined
          large
          width="100%"
          color="primary"
          disabled>
          Member hasn't saved
        </v-btn>
        <v-btn
          v-else
          outlined
          large
          width="100%"
          color="primary"
          :disabled="parseFloat(newNumber) <= 0"
          @click="addMemberSpending">
          Confirm (฿ {{ newNumber }} )
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    number: {
      type: String,
      required: true
    },
    isNewMember: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      buttons: [
        { key: '7', label: '7', color: '', class: 'headline' },
        { key: '8', label: '8', color: '', class: 'headline' },
        { key: '9', label: '9', color: '', class: 'headline' },
        { key: '4', label: '4', color: '', class: 'headline' },
        { key: '5', label: '5', color: '', class: 'headline' },
        { key: '6', label: '6', color: '', class: 'headline' },
        { key: '1', label: '1', color: '', class: 'headline' },
        { key: '2', label: '2', color: '', class: 'headline' },
        { key: '3', label: '3', color: '', class: 'headline' },
        { key: 'Clear', label: 'Clear', color: 'grey lighten-2', class: '' },
        { key: '0', label: '0', color: '', class: 'headline' },
        { key: 'Del', color: 'grey lighten-2', class: '', icon: 'mdi-backspace-outline' }
      ],
      newNumber: this.number
    }
  },
  watch: {
    newNumber (val) {
      const numberStr = parseFloat(val, 10)
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(numberStr)) {
        this.newNumber = '0'
      } else {
        this.newNumber = `${numberStr}`
      }
      this.$emit('on-update', this.newNumber)
    }
  },
  methods: {
    addMemberSpending () {
      this.$emit('OnConfirmCalculate')
    },
    InputKey (key) {
      if (key !== 'Clear' && key !== 'Del') {
        this.newNumber += key
      } else if (key === 'Del') {
        this.newNumber = this.newNumber.slice(0, -1)
      } else if (key === 'Clear') {
        this.newNumber = '0'
      }
    }
  }
}
</script>
